import { render } from "./OnlineTestsWrapper.vue?vue&type=template&id=7e07df17"
import script from "./OnlineTestsWrapper.vue?vue&type=script&lang=js"
export * from "./OnlineTestsWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__